module.exports = __webpack_public_path__ + "img/Hover_Brachless_Banking.1a980c17.png";